import { Input } from "antd";
import React from "react";

interface QuoteFormMessageBoxProps {
  message: string;
  setMessage: (value: string) => void;
}
const QuoteFormMessageBox = (props: QuoteFormMessageBoxProps) => {
  const { message, setMessage } = props;

  return (
    <div className="flex-col-stretch m-top-10" style={{alignItems: 'flex-start'}}>
      <span className="text-color-blue fw-500">
        Please Describe The Project<span className="text-color-red">*</span>
      </span>
      <Input.TextArea onChange={(e) => setMessage(e.target.value)} value={message} />
    </div>
  );
};
export default QuoteFormMessageBox;
